import * as yup from 'yup'

import UserModel from './user.model'
import { AddressSchema } from '@modules/resource/fields'
import { fieldTypes, format_useLabel, makeValidator } from '@modules/resource/resource.module'

const PayRateFields = ({ prefix }, props) => ([
	{
		key: 'payRate',
		type: 'number',
		label: `${prefix} Pay Rate`,
		...props,
	},
	{
		key: 'chargeRate',
		type: 'number',
		label: `${prefix} Charge Rate`,
		...props,
	},
])

const ClientModel = UserModel.extend({
	resourceKey: 'client',
}, [
	{
		key: 'name',
		toCSV: {
			include: 'never'
		},
	},
	{
		key: 'clientName',
		label: 'Client Name',
		type: 'text',
		required: 'conditional',
	},
	{
		key: 'clientID',
		label: 'Client ID',
		type: 'text',
	},
	{
		key: 'consultant',
		label: 'Assigned Consultant',
		type: 'resourceSelect',
		fieldProps: {
			resource: 'admin',
			isMulti: false,
			filter: item => item.status.key !== 'archived'
		},
		toCSV: {
			formatValue: format_useLabel,
		}
	},
	{
		key: 'bio',
		label: 'Important Client Information',
		type: 'textarea',
		required: 'never',
	},
	new AddressSchema(),
	{
		key: 'contacts',
		label: 'Contacts',
		type: 'fieldArray',
		fieldProps: {
			component: 'Contacts',
		},
		children: [
			{
				key: 'name',
				label: 'Contact Name',
				type: 'text',
			},
			{
				key: 'role',
				label: 'Contact Role',
				type: 'text',
			},
			{
				key: 'telephone',
				label: 'Phone Number',
				type: 'text',
			},
			{
				key: 'email',
				label: 'E-mail Address',
				type: 'email',
			}
		]
	},
	{
		key: 'documents',
		label: 'Documents',
		type: 'fileArray',
		toCSV: {
			include: 'never',
		}
	},
	{
		key: 'factored',
		label: 'Factored / Non Factored',
		type: 'radioGroup',
		fieldProps: {
			options: [
				{value: true, label: "Factored"},
				{value: false, label: "Non Factored"},
			]
		},
		toCSV: {
			formatValue: fieldTypes.yesNo.toCSV.formatValue
		}
	},
	{
		key: 'AWRApplicable',
		label: 'AWR Applicable',
		type: 'yesNo',
	},
	{
		key: 'holidayPayRate',
		label: 'Bank Holiday Pay Rate',
		type: 'number'
	},
	{
		key: 'jobTypeRates',
		label: 'Job Type Rates',
		type: 'fieldArray',
		fieldProps: {
			component: 'JobTypeRates',
		},
		children: [
			{
				key: 'jobType',
				label: 'Job Type',
				type: 'select',
				toCSV: {
					formatValue: format_useLabel,
				}
			},
			{
				key: 'standard',
				type: 'object',
				label: 'Standard',
				children: PayRateFields({ prefix: 'Standard' }),
			},
			{
				key: 'AWR',
				type: 'object',
				label: 'AWR',
				children: PayRateFields({ prefix: 'AWR' }, {
					required: 'never', // TODO: make it AWR PayRateFields required conditionally
				}),
			},
		]
	},
	{
		key: 'workingRequirements',
		label: 'Working Requirements',
		type: 'textarea',
		required: 'never',
	},
	{
		key: 'payrollNo',
		toCSV: {
			include: 'never',
		}
	}
]);

// TODO: remove window instances after development
window.ClientModel = ClientModel;

export default ClientModel;



// WEBPACK FOOTER //
// ./src/modules/user/models/client.model.js